import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import { useMemo } from "react";

export const useLiveUpdates = (entry) => {
  const memoizedEntry = useMemo(() => {
    if (entry?.sys?.id || !entry?.contentful_id) {
      return entry;
    }

    return {
      ...entry,
      sys: {
        id: entry.contentful_id,
      },
    };

  }, [entry?.sys?.id]);
  return useContentfulLiveUpdates(memoizedEntry)
};
